import React from 'react'

import { useHistory } from 'react-router-dom'

import Chip from 'components_new/atoms/Chip'
import Icon from 'components_new/atoms/Icon'

import { DashboardStatus } from 'types/GlobalDashboardGroup'
import type { TDashboardFolderDto } from '@homepal/api-contract'

export const isValidTitle = (title: string | null) => {
  if (title === '' || title === null) return false

  return !/kopia|namnlös/i.test(title)
}

export function FolderChip(props: {
  folder: TDashboardFolderDto | null
  status: DashboardStatus
}) {
  const { folder, status } = props
  const history = useHistory()

  let icon: 'Dashboards' | 'DesignServicesOutlined' | 'Folder' = 'Dashboards'
  let label = 'Alla dashboards'
  let onClick = () => history.push('/resources?type=dashboard')

  if (status === DashboardStatus.DRAFT) {
    icon = 'DesignServicesOutlined'
    label = 'Utkast'
    onClick = () => history.push('/resources?type=dashboard&tab=drafts')
  } else if (folder) {
    icon = 'Folder'
    label = folder.name
    onClick = () =>
      history.push(`/resources/folders/${folder.id}?type=dashboard`)
  }

  return (
    <Chip
      clickable={true}
      icon={<Icon name={icon} />}
      label={label}
      onClick={onClick}
    />
  )
}
